import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-content',
  templateUrl: './select-content.component.html',
  styleUrls: ['./select-content.component.scss']
})
export class SelectContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
